import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { StoreModule } from '@ngrx/store';
import * as fromNextSteps from './reducers/next-steps.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CreateNextStepEffects } from './effects/create-next-step.effects';
import { LoadNextStepsEffects } from './effects/load-next-steps.effects';
import { NextStepsContainerComponent } from './containers/next-steps-container/next-steps-container.component';
import { NextStepItemComponent } from './components/next-step-item/next-step-item.component';
import { AddNextStepComponent } from './components/add-next-step/add-next-step.component';
import { NextStepDetailsComponent } from './components/next-step-details/next-step-details.component';
import { LeadsSharedModule } from '@features/leads/shared/leads-shared.module';
import { NextStepFormComponent } from './shared/components/next-step-form/next-step-form.component';

@NgModule({
  declarations: [
    NextStepsContainerComponent,
    NextStepItemComponent,
    AddNextStepComponent,
    NextStepDetailsComponent,
    NextStepFormComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    IonicModule,
    LeadsSharedModule,
    StoreModule.forFeature(fromNextSteps.featureKey, fromNextSteps.reducer),
    EffectsModule.forFeature([CreateNextStepEffects, LoadNextStepsEffects]),
  ],
  exports: [
    NextStepsContainerComponent,
    NextStepItemComponent,
    AddNextStepComponent,
    NextStepDetailsComponent,
    NextStepFormComponent,
  ],
})
export class NextStepsModule {}
